import React, { Component } from 'react'
import Form from "../components/form/Form"
import TextAreaInput from "../components/form/TextAreaInput"
import TextInput from "../components/form/TextInput"
import Helmet from 'react-helmet'

import map from '../images/map.jpg'
import mark2 from '../images/mark2.png'

class contactPage extends Component {

  render() {
    return (
      <main id="main" role="main" style={{ marginTop: '134px', overflow: 'visible' }}>
      <Helmet title="LocusLabs - Contact Us"/>
        <section className="contact-section viewport-section">
          <div className="container">
            <div className="form-area">
                <Form title="Contact Us" description={{__html: 'For technical support and content management queries, please access the links at the bottom of this page. For pricing, or to schedule a demo of our products please use <a href="/#contact">this form</a><br/><br/>For all other inquiries, please fill out the form below and we will be touch shortly:<br/>'}} submit="SEND MESSAGE">
                    <TextInput type="text" placeholder="Name..." name="name" required={true}/>
                    <TextInput type="text" placeholder="Company..." name="company" required={true} />
                    <TextInput type="email" placeholder="Email..." name="email" required={true} />
                    <TextInput type="text" placeholder="How did you hear about us..." name="referral" required={true} />
                    <TextAreaInput placeholder="How can we help you..." name="details" required={true}/>
                </Form>
            </div>
            <div className="map-wrap">
              <img src={map} alt="" width="514" height="514" />
              <div className="mark">
                <img
                  src={mark2}
                  alt=""
                  width="60"
                  height="59"
                />
              </div>
              <div className="pop-up">
                <p>
                  LocusLabs, Inc. <br />331 Jefferson Street <br />Oakland, CA
                  94607 <br />USA
                </p>
              </div>
            </div>
          </div>
        </section>
      </main>
    )
  }

}
export default contactPage



// WEBPACK FOOTER //
// ./src/pages/contact.js